///<reference path="./smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../../../common/security.keys.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export abstract class DataTemplateSecurity extends DataTemplateBase implements ISecureDataTemplate {
        securityAccess: SecurityAccessEnum;
        globalErrorMessage?: string;

        abstract collection: ICollectionBase<any>;
        abstract allSelectedSecurityKey: SecurityKeys;
        abstract securityErrorMessage: string;

        get hasSecurity(): boolean {
            return true;
        }

        get securityFailed(): boolean {
            return this.securityAccess !== SecurityAccessEnum.Grant;
        }

        getSecurityErrorMessage($translate: ng.translate.ITranslateService, data: Dictionary<any> = {}): string {
            return $translate.instant(this.securityErrorMessage, data);
        }

        checkSecurityKey(securityService: Meevo.Components.Common.ISecurityService) {
            securityService.checkSecurityKey(this.allSelectedSecurityKey as string)
                .then((permission: SecurityAccessEnum) => this.securityAccess = permission)
                .catch(() => this.securityAccess = SecurityAccessEnum.Deny)
                .finally(() => {
                    if (this.securityAccess !== SecurityAccessEnum.Grant) {
                        this.onSecurityFail();
                    }
                })
        }

        protected abstract onSecurityFail();
    }
}